import { SlideButtonProps } from '../../../types';
import { FirstSlideIcon } from '../../atoms/FirstSlideIcon';
import { PresentationNavigationButton } from '../../atoms/PresentationNavigationButton';
import { useTranslation } from 'react-i18next';

export const FirstSlideButton = (props: SlideButtonProps) => {
    const { t } = useTranslation();
    const { onClick, classNames } = props;
    return (
        <PresentationNavigationButton type="button" onClick={onClick} className={`${classNames}`} testId="FirstButtonClick">
            <span className="sr-only">{t('Slide.Button.First')}</span>
            <FirstSlideIcon />
        </PresentationNavigationButton>
    );
};
